import { render, staticRenderFns } from "./schoolInfo.vue?vue&type=template&id=3d9d34d4&scoped=true&"
import script from "./schoolInfo.vue?vue&type=script&lang=js&"
export * from "./schoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./schoolInfo.vue?vue&type=style&index=0&id=3d9d34d4&prod&scoped=true&lang=css&"
import style1 from "./schoolInfo.vue?vue&type=style&index=1&id=3d9d34d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d34d4",
  null
  
)

export default component.exports